import { GridApi } from 'ag-grid-community';

export const getCurrentVisibleColumns = (gridApi: GridApi | null): string[] => {
  const currentColDefs = gridApi?.getColumnDefs();

  const currentVisibleCols: string[] = [];
  currentColDefs?.forEach((colDef) => {
    if (!('colId' in colDef) || !colDef.colId) {
      return;
    }
    if (!colDef.hide) {
      currentVisibleCols.push(colDef.colId);
    }
  });

  return currentVisibleCols;
};
